<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li><a routerLink="/configurar-administracion">Configuración Administración</a></li>
        <li><a routerLink="/zonas-listado">Listado de Zonas</a></li>
        <li>Modificar Zona</li>
      </ul>
      <h2>Modificar Zona</h2>
      <h4 *ngIf="catalogo">{{catalogo.concepto}}</h4>
    </div>
  </div>
</div>

<div class="andorra-apply-content ptb-70 animate__animated animate__fadeInBottomRight">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="updateZona()">

            <div class="row">
              <div class="col-lg-12">

                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Zona</mat-label>
                    <input formControlName="zona" matInput placeholder="Zona" 
                           [class.is-invalid]="zonaNoValida" autocomplete="off">
                    <mat-error *ngIf="zonaNoValida">Ingrese una zona</mat-error>
                  </mat-form-field>
                </div>

                <div class="form-group">
                  <mat-slide-toggle formControlName="activa">Activa</mat-slide-toggle>
                </div>

                <!-- Sección para seleccionar localidades -->
                <div class="form-group" *ngIf="localidadesOrdenadas.length > 0">
                  <h3>Asignar a localidades</h3>
                  <p>Seleccione las localidades a las que desea asignar esta zona:</p>
                  
                  <div class="localidades-container" style="max-height: 300px; overflow-y: auto; border: 1px solid #eee; padding: 15px;">
                    <div class="row">
                      <div *ngFor="let localidad of localidadesOrdenadas" class="col-lg-4 col-md-6 col-sm-6 localidad-item" style="margin-bottom: 15px;">
                        <mat-checkbox (change)="onLocalidadSeleccionada($event, localidad._id)" 
                                     [checked]="esLocalidadDeEstaZona(localidad)">
                          {{ localidad.nombre }}
                          <span *ngIf="getNombreZona(localidad)" style="font-size: 0.9em; color: #666;">
                            (Zona actual: {{ getNombreZona(localidad) }})
                          </span>
                          <span *ngIf="!getNombreZona(localidad)" style="font-size: 0.9em; color: #666;">
                            (Sin zona asignada)
                          </span>
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                  
                  <small *ngIf="localidadesSeleccionadas.size > 0" style="color: #666; display: block; margin-top: 10px;">
                    {{ localidadesSeleccionadas.size }} localidad(es) seleccionada(s)
                  </small>
                  <small *ngIf="localidadesSeleccionadas.size === 0" style="color: #999; display: block; margin-top: 10px;">
                    Ninguna localidad seleccionada
                  </small>
                </div>

              </div>

              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <button type="button" routerLink="/zonas-listado" class="btn btn-warning">Cancelar</button>
                </div>

                <div class="col-lg-4 col-md-4">
                  <button [disabled]="!form.valid" type="submit" class="btn btn-primary">Guardar</button>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-spinner 
    [show]="showSpinner"
    [text]="spinnerText"
    [type]="'fullscreen'"
    [color]="'#B1476A'"
    [blurBackground]="true">
</app-spinner> -->